<template>
  <div class="app-container">
    <van-nav-bar
      title="开通分站"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div>
      <!-- 已开通分站  -->
      <div v-if="branchId">
        <el-result icon="success" title="您已开通分站~"> </el-result>
        <div style="padding: 0px 15px">
          <van-cell-group>
            <van-field v-model="vipUrl" label="分站地址" readonly />
            <van-field v-model="vipBackUrl" label="管理后台" readonly />
          </van-cell-group>
        </div>
      </div>

      <!-- 开通分站 -->
      <div v-else>
        <div class="open-substation-image">
          <img src="@/assets/vip-bg.png" style="width: 100%" />
        </div>

        <div class="open-substation-bottom" style="padding: 30px">
          <van-button round type="info" block @click="dialogVisible = true">
            立即开通
          </van-button>
        </div>
      </div>

      <el-dialog
        title="开通分站"
        :visible.sync="dialogVisible"
        center
        append-to-body
        width="90%"
        class="class1"
      >
        <div>
          <div class="dialog-content">
            <div class="layui-card-body">
              <ul class="mvip-type">
                <li
                  class="meal"
                  :class="{ act: index === selectIndex }"
                  v-for="(item, index) in mealList"
                  :key="index"
                  @click="selectedIndex(item, index)"
                >
                  <div class="meal-name">
                    {{ item.mealName }}
                    <p>￥{{ item.mealPrice }} 元</p>
                  </div>
                  <div class="meal-price">赠送：{{ item.levelName }}</div>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <el-form
              :model="fzForm"
              :rules="rules"
              ref="fzForm"
              label-position="top"
            >
              <el-form-item label="分站名称" prop="name">
                <el-input v-model="fzForm.name"></el-input>
              </el-form-item>

              <el-form-item label="绑定域名" required>
                <el-col :span="14">
                  <el-form-item prop="prefixDomain">
                    <el-input v-model="fzForm.prefixDomain"></el-input>
                  </el-form-item>
                </el-col>

                <span>&nbsp;</span>

                <el-col :span="9">
                  <el-form-item prop="suffixDomain">
                    <el-select
                      v-model="fzForm.suffixDomain"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in domainList"
                        :key="item.domain"
                        :label="item.domain"
                        :value="item.domain"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-form-item>

              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('fzForm')"
                  style="width: 100%"
                  v-preventClick
                  >确认开通
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { createFz, getDomainList, getMealList, getVipAddress } from "@/api/vip";
// import { getDomain } from "@/api/index";
import { Message } from "element-ui";
import { mapState } from "vuex";

export default {
  data() {
    return {
      dialogVisible: false,
      dialogOpenVisible: false,
      fzAddress: "",
      userName: "",
      password: "",
      fzObject: [
        { title: "轮播图自定义" },
        { title: "商品标题修改" },
        { title: "商品图片修改" },
        { title: "商品价格修改" },
        { title: "商品内容修改" },
        { title: "允许查看订单" },
        { title: "继承主站价格体系" },
      ],
      fzForm: {
        name: undefined,
        suffixDomain: undefined,
        prefixDomain: undefined,
        mealId: undefined,
      },
      rules: {
        name: [
          { required: true, message: "请输入分站名称", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        suffixDomain: [
          { required: true, message: "请输入二级域名前缀", trigger: "change" },
        ],
        prefixDomain: [
          { required: true, message: "请选择二级域名后缀", trigger: "change" },
        ],
        // userName: [
        //   { required: true, message: "请输入管理账号", trigger: "change" },
        // ],
        // password: [
        //   { required: true, message: "请输入管理密码", trigger: "change" },
        // ],
        // prefixDomain: [
        //   {
        //     required: true,
        //     message: "请至少选择一个后缀域名",
        //     trigger: "change",
        //   },
        // ],
      },
      domainList: [],
      mealList: [],
      selectIndex: 1,
      vipUrl: undefined,
      vipBackUrl: undefined,
    };
  },
  computed: {
    ...mapState({
      branchId: (state) => state.user.branchId,
    }),
  },
  created() {
    console.log(this.branchId);
    // this.load();
    this.queryDomain();
    //查询套餐列表
    this.queryMealList();
    //获取分站信息
    this.queryVipInfo();
  },
  methods: {
    /**
     * 查询主站后缀
     */
    queryDomain() {
      var data = {};
      //开通分站
      new Promise((resolve, rejust) => {
        getDomainList(data)
          .then((res) => {
            this.domainList = res.result.list;
            resolve();
          })
          .catch((error) => {
            rejust(error);
          });
      });
    },

    /**
     * 查询套餐列表
     */
    queryMealList() {
      var data = {};
      //开通分站
      new Promise((resolve, rejust) => {
        getMealList(data)
          .then((res) => {
            this.mealList = res.result.list;
            resolve();
          })
          .catch((error) => {
            rejust(error);
          });
      });
    },

    selectedIndex(value, index) {
      this.selectIndex = index;
      this.fzForm.mealId = value.id;
    },

    /**
     * 创建分站
     */
    submitForm(formName) {
      console.log(this.fzForm.mealId);
      if (this.fzForm.mealId === undefined) {
        this.$message({
          message: "请选择套餐版本",
          type: "warning",
        });
        return;
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          //开通分站
          new Promise((resolve, rejust) => {
            createFz(this.fzForm)
              .then((res) => {
                if (res.status == 0) {
                  Message({
                    message: "开通成功",
                    type: "success",
                    duration: 5 * 1000,
                  });
                  this.$store.dispatch("user/info");
                  this.dialogVisible = false;
                  this.queryVipInfo();
                }
                resolve();
              })
              .catch((error) => {
                rejust(error);
              });
          });
        } else {
          return false;
        }
      });
    },

    /**
     * 获取分站信息
     */
    queryVipInfo() {
      new Promise((resolve, rejust) => {
        getVipAddress()
          .then((res) => {
            console.log(res);
            this.vipUrl = res.result.url;
            this.vipBackUrl = res.result.url + "/vip";

            resolve();
          })
          .catch((error) => {
            rejust(error);
          });
      });
    },

    resetForm() {
      this.fzForm.name = "";
      this.fzForm.domains = "";
      this.fzForm.password = "";
      this.fzForm.userName = "";
    },

    //跳转到我的页面
    onClickLeft() {
      console.log("_-------------");
      this.$router.push("/my");
    },
  },
};
</script>
<style>
/* 套餐列表css */
.layui-card-body {
  position: relative;
  padding: 20px 0;
  line-height: 24px;
}
.mvip-type {
  white-space: pre;
  display: flex;
  align-items: center;
  /* justify-content: center; */
}
.mvip-type .meal.act {
  color: #fff;
  border: 2px solid #2564e9;
  background: linear-gradient(180deg, #2f68e7, #3b8cfe);
}
.mvip-type .meal {
  width: 150px;
  height: 120px;
  margin-right: 10px;
  text-align: center;
  border-radius: 4px;
  padding: 15px 20px;
  font-style: normal;
  border: 2px solid #eee;
  position: relative;
  cursor: pointer;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.mvip-type .meal.act:before {
  content: "";
  width: 38px;
  height: 38px;
  position: absolute;
  right: -2px;
  bottom: -2px;
  /* background: url(../../static/img/lower-select-ltd.1e2a1a1f.svg) no-repeat 100% 100%; */
  background-size: 38px;
  border-radius: inherit;
}

.mvip-type .meal .meal-name {
  padding-bottom: 8px;
  border-bottom: 1px dashed #ccc;
  font-size: 20px;
  text-align: center;
}

.mvip-type .meal .meal-name p {
  margin-top: 3px;
  font-size: 14px;
}

.mvip-type .meal .meal-price {
  margin-top: 8px;
  font-size: 12px;
}

.mvip-type .meal.act:after {
  content: "";
  /* background: url(data:image/png;base64,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) no-repeat 0 100%; */
  width: 110px;
  height: 92px;
  position: absolute;
  left: -26px;
  bottom: -14px;
  background-size: 100%;
}

.open-substation-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3.5rem;
  background-color: #fff;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.class1 .el-dialog {
  border-radius: 10px;
}

.dialog-content {
  overflow-y: auto; /* 设置垂直方向溢出时显示滚动条 */
}
</style>
